// Interpersonal Skills organized by subcategories
export const INTERPERSONAL_SKILLS_CATEGORIES = [
  {
    name: 'Communication',
    skills: [
      'Active Listening', 'Verbal Communication', 'Nonverbal Communication',
      'Clear Expression', 'Feedback Delivery', 'Question Techniques',
      'Presentation Skills', 'Public Speaking', 'Written Communication',
      'Storytelling', 'Persuasive Communication', 'Cross-cultural Communication',
      'Diplomatic Communication', 'Assertive Communication', 'Empathetic Communication'
    ]
  },
  {
    name: 'Relationship Building',
    skills: [
      'Networking', 'Trust Building', 'Rapport Building',
      'Relationship Management', 'Team Building', 'Partnership Development',
      'Collaboration Skills', 'Social Skills', 'Interpersonal Relations',
      'Professional Relationships', 'Community Building', 'Alliance Building',
      'Stakeholder Relations', 'Client Relations', 'Peer Relations'
    ]
  },
  {
    name: 'Emotional Intelligence',
    skills: [
      'Self-awareness', 'Emotional Awareness', 'Self-regulation',
      'Empathy', 'Social Awareness', 'Emotional Management',
      'Stress Management', 'Resilience', 'Adaptability',
      'Impulse Control', 'Emotional Expression', 'Relationship Management',
      'Social Skills', 'Emotional Understanding', 'Personal Growth'
    ]
  },
  {
    name: 'Conflict Resolution',
    skills: [
      'Mediation', 'Negotiation', 'Problem Solving',
      'Conflict Management', 'Dispute Resolution', 'Peace Building',
      'Consensus Building', 'Compromise Skills', 'Conflict Prevention',
      'Resolution Strategies', 'De-escalation', 'Agreement Building',
      'Reconciliation', 'Conflict Analysis', 'Solution Development'
    ]
  },
  {
    name: 'Leadership',
    skills: [
      'Team Leadership', 'Vision Setting', 'Decision Making',
      'Motivation Skills', 'Delegation', 'Mentoring',
      'Coaching', 'Influence', 'Strategic Thinking',
      'Change Management', 'Performance Management', 'Team Development',
      'Leadership Style', 'Inspirational Leadership', 'Servant Leadership'
    ]
  },
  {
    name: 'Team Collaboration',
    skills: [
      'Team Building', 'Group Dynamics', 'Collaborative Work',
      'Team Communication', 'Role Understanding', 'Shared Goals',
      'Team Support', 'Group Facilitation', 'Team Coordination',
      'Project Collaboration', 'Team Spirit', 'Collective Problem Solving',
      'Team Synergy', 'Cross-functional Work', 'Team Motivation'
    ]
  },
  {
    name: 'Cultural Competence',
    skills: [
      'Cultural Awareness', 'Diversity Appreciation', 'Cultural Sensitivity',
      'Global Mindset', 'Cross-cultural Communication', 'Cultural Adaptation',
      'Inclusive Behavior', 'Cultural Understanding', 'International Relations',
      'Cultural Intelligence', 'Multicultural Work', 'Cultural Respect',
      'Global Perspective', 'Cultural Integration', 'Cultural Bridge Building'
    ]
  },
  {
    name: 'Professional Etiquette',
    skills: [
      'Business Etiquette', 'Professional Conduct', 'Workplace Manners',
      'Social Protocol', 'Professional Image', 'Meeting Etiquette',
      'Email Etiquette', 'Phone Etiquette', 'Networking Etiquette',
      'Dining Etiquette', 'Professional Courtesy', 'Business Protocol',
      'Professional Boundaries', 'Social Grace', 'Professional Standards'
    ]
  },
  {
    name: 'Influence and Persuasion',
    skills: [
      'Persuasion Skills', 'Negotiation', 'Influence Techniques',
      'Strategic Communication', 'Stakeholder Management', 'Change Leadership',
      'Motivation Skills', 'Presentation Skills', 'Sales Communication',
      'Relationship Building', 'Trust Development', 'Consensus Building',
      'Opinion Leadership', 'Behavioral Change', 'Impact Creation'
    ]
  },
  {
    name: 'Adaptability',
    skills: [
      'Flexibility', 'Change Management', 'Resilience',
      'Learning Agility', 'Stress Management', 'Crisis Management',
      'Problem Solving', 'Situational Awareness', 'Emotional Regulation',
      'Cognitive Flexibility', 'Adaptive Thinking', 'Change Readiness',
      'Coping Skills', 'Mental Agility', 'Response Adaptation'
    ]
  },
  {
    name: 'Mentoring and Coaching',
    skills: [
      'Skill Development', 'Performance Coaching', 'Career Guidance',
      'Knowledge Transfer', 'Professional Development', 'Growth Support',
      'Feedback Provision', 'Goal Setting', 'Progress Monitoring',
      'Development Planning', 'Success Support', 'Potential Development',
      'Mentorship Skills', 'Learning Facilitation', 'Achievement Support'
    ]
  },
  {
    name: 'Problem Solving',
    skills: [
      'Critical Thinking', 'Analysis Skills', 'Solution Development',
      'Decision Making', 'Creative Problem Solving', 'Strategic Thinking',
      'Root Cause Analysis', 'Issue Resolution', 'Conflict Management',
      'Process Improvement', 'Innovation Skills', 'Analytical Thinking',
      'Problem Prevention', 'Solution Implementation', 'Results Achievement'
    ]
  }
];

// Export flattened list for backward compatibility
export const INTERPERSONAL_SKILLS = INTERPERSONAL_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
